import { render, staticRenderFns } from "./DangerButton.vue?vue&type=template&id=257c6052&"
import script from "./DangerButton.vue?vue&type=script&lang=ts&"
export * from "./DangerButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports